import type { ReactElement, ReactNode } from "react";
import { Link } from "react-router";

export interface PageHeadingProps {
  readonly title: string;
  /** Buttons at the right of the title, e.g. "Sponsor anlegen". */
  readonly actions?: ReactNode;
  /** A way back to the list this page belongs to. */
  readonly back?: { readonly to: string; readonly label: string };
}

/**
 * The page title, the largest heading of the page (D43): until 19.10.2026 a 14 px tag in
 * capitals, smaller than the section headings under it.
 *
 * Title only: explanations belong on the help page, a "?" at a field where one is needed.
 */
export function PageHeading({ title, actions, back }: PageHeadingProps): ReactElement {
  return (
    <div className="mb-6">
      {back !== undefined ? (
        <Link
          className="mb-3 inline-block text-sm text-muted-foreground underline-offset-4 hover:text-foreground hover:underline"
          to={back.to}
        >
          ← {back.label}
        </Link>
      ) : null}
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <h1 className="font-sans text-2xl font-bold">
          {title}
        </h1>
        {actions !== undefined ? (
          <div className="flex flex-wrap gap-2 empty:hidden">{actions}</div>
        ) : null}
      </div>
    </div>
  );
}
